module.exports = __webpack_public_path__ + "static/media/12.bf3c8e8b.avif";